import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/admin")({
  component: AdminGateway,
});

function AdminGateway() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate({
        to: "/login",
        replace: true,
        search: { context: "admin", redirect: "/app/admin" } as never,
      });
    } else {
      navigate({ to: "/app/admin", replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="size-12 rounded-full border-4 border-clay border-t-primary animate-spin" />
    </div>
  );
}
